<div class="dialogContainer" [ngClass]="{ 'visible' : showModal }">
  <div class="dialog">
    @if (form != null) {
      <div class="grid-container">
        <div class="grid-x" [formGroup]="form">
          <div class="cell large-9 medium-9 small-9 bold text-align-left">
            <h3>Edit Casing Tubing Record</h3>
          </div>
          <div class="cell large-3 medium-3 small-3">
            <span class="minor-margin-right">
              <button class="button" (click)="save()" [disabled]="form?.invalid">Save</button>
            </span>
            <span>
              <button class="button" (click)="close()">Close</button>
            </span>
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            Casing Type:
          </div>
          <div class="cell large-2 medium-2 small-6">
            {{ getCasingType(form?.get('type')?.value) }}
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            <label for="wellboreDiameter">Wellbore Diameter:</label>
          </div>
          <div class="cell large-2 medium-2 small-6">
            <input id="wellboreDiameter" type="number" min="0" formControlName="wellboreDiameter" autofocus />
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            <label for="casingDiameter">Casing Diameter:</label>
          </div>
          <div class="cell large-2 medium-2 small-6">
            <input id="casingDiameter" type="number" min="0" formControlName="casingDiameter" />
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            <label for="collarDiameter">Collar Diameter:</label>
          </div>
          <div class="cell large-2 medium-2 small-6">
            <input id="collarDiameter" type="number" min="0" formControlName="collarDiameter" />
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            <label for="feetInstalled">Feet Installed:</label>
          </div>
          <div class="cell large-2 medium-2 small-6">
            <input id="feetInstalled" type="number" min="0" formControlName="feetInstalled" />
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            <label for="feetLeftInWell">Feet Left In Well:</label>
          </div>
          <div class="cell large-2 medium-2 small-6">
            <input id="feetLeftInWell" type="number" min="0" formControlName="feetLeftInWell" />
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            <label for="cementVolume">Cement Volume (Sacks):</label>
          </div>
          <div class="cell large-2 medium-2 small-6">
            <input id="cementVolume" type="number" min="0" formControlName="cementVolume" />
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            <label for="cementTop">Cement Top:</label>
          </div>
          <div class="cell large-2 medium-2 small-6">
            <input id="cementTop" type="number" min="0" formControlName="cementTop" />
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            <label for="grade">Grade:</label>
          </div>
          <div class="cell large-2 medium-2 small-6">
            <input id="grade" type="number" min="0" formControlName="grade" />
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            <label for="weight">Weight:</label>
          </div>
          <div class="cell large-2 medium-2 small-6">
            <input id="weight" type="number" min="0" formControlName="weight" />
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            <label for="burstPressureRating">Burst Pressure Rating:</label>
          </div>
          <div class="cell large-2 medium-2 small-6">
            <input id="burstPressureRating" type="number" min="0" formControlName="burstPressureRating" />
          </div>
          <div class="cell large-4 medium-4 small-6 bold text-align-right padding-right">
            <label for="bottom">Bottom:</label>
          </div>
          <div class="cell large-2 medium-2 small-6">
            <input id="bottom" type="number" min="0" formControlName="bottom" />
          </div>
          <div class="cell large-6 medium-6 small-6 bold text-align-right padding-right">
            <label for="toolType">Tool Type:</label>
          </div>
          <div class="cell large-4 medium-4 small-6">
            <select id="toolType" formControlName="toolType">
              @for (tool of tools; track tool) {
                <option [value]="tool.code">{{tool.definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-2 medium-2 small-12">&nbsp;</div>
          <div class="cell large-3 medium-3 small-6 bold text-align-right padding-right">
            @if (form?.get('comments')?.invalid && form?.get('comments')?.touched) {
              <span class="bold red">
                Comments is invalid
              </span>
            }
            <label for="comments">Comments</label>
          </div>
          <div class="cell large-9 medium-9 small-6 text-align-left">
            <div id="comments" formControlName="comments" [froalaEditor]="froalaOptions"></div>
          </div>
        </div>
      </div>
    }
  </div>
</div>